var _rect, _path, _path2, _ellipse, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCloseHovering = function SvgCloseHovering(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 71,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M35 50.5C44.665 50.5 52.5 42.665 52.5 33C52.5 23.335 44.665 15.5 35 15.5C25.335 15.5 17.5 23.335 17.5 33C17.5 42.665 25.335 50.5 35 50.5Z",
    fill: "#90CAF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8549 32.9999L40.8799 28.9749C41.3874 28.4674 41.3874 27.6274 40.8799 27.1199C40.3724 26.6124 39.5324 26.6124 39.0249 27.1199L34.9999 31.1449L30.9749 27.1199C30.4674 26.6124 29.6274 26.6124 29.1199 27.1199C28.6124 27.6274 28.6124 28.4674 29.1199 28.9749L33.1449 32.9999L29.1199 37.0249C28.6124 37.5324 28.6124 38.3724 29.1199 38.8799C29.3824 39.1424 29.7149 39.2649 30.0474 39.2649C30.3799 39.2649 30.7124 39.1424 30.9749 38.8799L34.9999 34.8549L39.0249 38.8799C39.2874 39.1424 39.6199 39.2649 39.9524 39.2649C40.2849 39.2649 40.6174 39.1424 40.8799 38.8799C41.3874 38.3724 41.3874 37.5324 40.8799 37.0249L36.8549 32.9999Z",
    fill: "#90CAF9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 35.5,
    cy: 63.5,
    rx: 27.5,
    ry: 2.5,
    fill: "url(#paint0_radial_409_47198)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_409_47198",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.3333 62.6667) rotate(-180) scale(25.8333 3.33333)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DD3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF8FF",
    stopOpacity: 0.3
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCloseHovering);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "close-hovering.0eae22d9d9c9807fe7e48ae7f3aa884b.svg";